
import React from 'react';
import { 
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { usePaymentCredentials } from '../hooks/usePaymentCredentials';
import { Loader } from 'lucide-react';

interface StripeConfigDialogProps {
  shopId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSaved?: () => void;
}

export const StripeConfigDialog: React.FC<StripeConfigDialogProps> = ({
  shopId,
  open,
  onOpenChange,
  onSaved
}) => {
  const {
    apiKey, 
    setApiKey,
    apiSecret, 
    setApiSecret,
    isSaving,
    isLoading,
    handleSaveCredentials
  } = usePaymentCredentials(shopId, 'stripe');

  const handleSave = async () => {
    const success = await handleSaveCredentials();
    if (success) {
      if (onSaved) onSaved();
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Configuration Stripe</DialogTitle>
        </DialogHeader>
        
        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <Loader className="h-6 w-6 animate-spin text-primary" />
            <span className="ml-2">Chargement des identifiants...</span>
          </div>
        ) : (
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="stripe-api-key">Clé API publique</Label>
              <Input
                id="stripe-api-key"
                type="text"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="pk_test_..."
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="stripe-api-secret">Clé API secrète</Label>
              <Input
                id="stripe-api-secret"
                type="password"
                value={apiSecret}
                onChange={(e) => setApiSecret(e.target.value)}
                placeholder="sk_test_..."
              />
              <p className="text-xs text-muted-foreground">Cette clé sera chiffrée avant d'être stockée.</p>
            </div>
          </div>
        )}
        
        <DialogFooter>
          <Button
            onClick={handleSave}
            disabled={isLoading || isSaving || (!apiKey || !apiSecret)}
          >
            {isSaving ? 'Enregistrement...' : 'Enregistrer les identifiants'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
